<p-dialog header="Cancellation Remarks" [(visible)]="showCancelPopup" modal="modal" width="500" >
  <ara-textarea [sourceText]="cancellationReason" [maxLength]="1000" [disabled]="Status==='Cancelled'"
    (output)="getRemarks($event,'CancellationReason')"></ara-textarea>
  <div *ngIf="showCancellationmsg && !cancellationReason ">
    <span class="error-msg-colour">{{ 'ACTIONTRACKER.PLEASE_ENTER_CANCELLATION_REMARKS.' | translate }}</span>
  </div>
  <ara-file-upload [accept]="accept" multiple="true" [(inputFiles)]="record.CancelFiles"
    [disabled]="Status==='Cancelled'" (onInputFilesUpdatedData)="onInputFilesUpdated($event,'Cancel')">
  </ara-file-upload>
  <p-footer>
    <button *ngIf="Status!=='Cancelled'" type="button" (click)="checkPopUpValidation('Cancel',SourceId)" label=""
      class="btn btn-primary">Submit</button>
    <button type="button" (click)="closeCancelPopup()" label="Cancel" class="btn btn-primary">Cancel</button>
  </p-footer>
</p-dialog>
<p-dialog header="Deletion Remarks" [(visible)]="showDeletePopup" modal="modal" width="500" >
  <ara-textarea [sourceText]="deletionReason" [maxLength]="1000" [disabled]="Status==='Deleted'"
    (output)="getRemarks($event,'DeletionReason')"></ara-textarea>
  <div *ngIf="showDeletionmsg && !deletionReason ">
    <span class="error-msg-colour">{{ 'ACTIONTRACKER.PLEASE_ENTER_DELETION_REMARKS.' | translate }}</span>
  </div>
  <ara-file-upload [accept]="accept" multiple="true" [(inputFiles)]="record.DeleteFiles" [disabled]="Status==='Deleted'"
    (onInputFilesUpdatedData)="onInputFilesUpdated($event,'Delete')">
  </ara-file-upload>
  <p-footer>
    <button *ngIf="Status!=='Deleted'" type="button" (click)="checkPopUpValidation('Delete',SourceId)" label=""
      class="btn btn-primary">Submit</button>
    <button type="button" (click)="closeDeletePopup()" label="Cancel" class="btn btn-primary">Cancel</button>
  </p-footer>
</p-dialog>
<p-dialog header="Restate Remarks" [(visible)]="showRestatePopup" modal="modal" width="500" >
  <ara-textarea [sourceText]="restateReason" [maxLength]="1000" [disabled]="Status==='Restate'"
    (output)="getRemarks($event,'RestateReason')"></ara-textarea>
  <div *ngIf="showRestatemsg && !restateReason ">
    <span class="error-msg-colour">{{ 'OBSERVATION.RESTATE_OBSERVATION' | translate }}</span>
  </div>
  <ara-file-upload [accept]="accept" multiple="true" [(inputFiles)]="record.RestateFiles"
    [disabled]="Status==='Restate'" (onInputFilesUpdatedData)="onInputFilesUpdated($event,'Restate')">
  </ara-file-upload>
  <p-footer>
    <button *ngIf="Status==='Cancelled' || Status==='Closed'" type="button" (click)="checkPopUpValidation('Restate',SourceId)"
      label="Restate" class="btn btn-primary">Submit</button>
    <button type="button" (click)="closeRestatePopup()" label="Cancel" class="btn btn-primary">Cancel</button>
  </p-footer>
</p-dialog>

<p-dialog header="Restore Remarks" [(visible)]="showRestorePopup" modal="modal" width="500" >
  <ara-textarea [sourceText]="RestoreReason" [maxLength]="1000" [disabled]="Status==='Restored'"
    (output)="getRemarks($event,'RestoreReason')"></ara-textarea>
  <div *ngIf="showRestoremsg && !RestoreReason ">
    <span class="error-msg-colour">Please Enter Restore Remark</span>
  </div>
  
  <p-footer>
    <button *ngIf="Status!=='Restored'" type="button" (click)="checkPopUpValidation('Restore',SourceId)" label=""
      class="btn btn-primary">Submit</button>
    <button type="button" (click)="closeRestorePopup()" label="Cancel" class="btn btn-primary">Cancel</button>
  </p-footer>
</p-dialog>

<p-dialog header="Approve Record" [(visible)]="showAcceptPopup" modal="modal" width="500" >
  <ara-textarea [sourceText]="AcceptReason" [maxLength]="1000" 
    (output)="getRemarks($event,'AcceptReason')"></ara-textarea>
  <div *ngIf="showAcceptmsg && !AcceptReason ">
    <span class="error-msg-colour">{{ 'RISK.KINDLY_ENTER_REMARKS' | translate }}</span>
  </div>
  
  <p-footer>
    <button  type="button" (click)="checkPopUpValidation('Accept',SourceId)" label=""
      class="btn btn-primary">Submit</button>
    <button type="button" (click)="closeAcceptPopup()" label="Cancel" class="btn btn-primary">Cancel</button>
  </p-footer>
</p-dialog>

<p-dialog header="Reject" [(visible)]="showRejectPopup" modal="modal" width="500" >
  <ara-textarea [sourceText]="RejectReason" [maxLength]="1000" 
    (output)="getRemarks($event,'RejectReason')"></ara-textarea>
  <div *ngIf="showRejectmsg && !RejectReason ">
    <span class="error-msg-colour">{{ 'RISK.KINDLY_ENTER_REMARKS' | translate }}</span>
  </div>
  
  <p-footer>
    <button  type="button" (click)="checkPopUpValidation('Reject',SourceId)" label=""
      class="btn btn-primary">Submit</button>
    <button type="button" (click)="closeRejectPopup()" label="Cancel" class="btn btn-primary">Cancel</button>
  </p-footer>
</p-dialog>

<div class="sub-section-wrapper">
  <a (click)="modifyRecord('Cancel')" class="cursor-pointer padding-right-5" *ngIf="ShowCancel">
    <i class="fa fa-times" data-toggle="tooltip" pTooltip="Cancel Record" tooltipPosition="top"></i>
    <ng-container *ngIf="ShowLabel" class="padding-left-5">Cancel</ng-container>
  </a>
  <a (click)="modifyRecord('Delete')" class="cursor-pointer padding-right-5" *ngIf="ShowDelete">
    <i class="fa fa-trash" data-toggle="tooltip" pTooltip="Delete Record" tooltipPosition="top"></i>
    <ng-container *ngIf="ShowLabel" class="padding-left-5">Delete</ng-container>
  </a>
  <a (click)="modifyRecord('Restate')" class="cursor-pointer" *ngIf="ShowRestate">
    <i class="fa fa-undo" data-toggle="tooltip" pTooltip="Restate Record" tooltipPosition="top"></i>
    <ng-container *ngIf="ShowLabel" class="padding-left-5">Restate</ng-container>
  </a>
  <a (click)="modifyRecord('Restore')" class="cursor-pointer" *ngIf="ShowRestore">
    <i class="fa fa-undo" data-toggle="tooltip" pTooltip="Restore Record" tooltipPosition="top"></i>
    <ng-container *ngIf="ShowLabel" class="padding-left-5">Restore</ng-container>
  </a>
  <a (click)="modifyRecord('Accept')" class="btn btn-primary button-submit" *ngIf="ShowAccept">
    <!-- <i class="fa fa-trash" data-toggle="tooltip" pTooltip="Approve Record" tooltipPosition="top"></i> -->
    <ng-container *ngIf="ShowLabel" class="padding-left-5">Approve</ng-container>
  </a>
  <a (click)="modifyRecord('Reject')" class="btn btn-primary button-reject" *ngIf="ShowReject">
    <!-- <i class="fa fa-trash" data-toggle="tooltip" pTooltip="Reject Record" tooltipPosition="top"></i> -->
    <ng-container *ngIf="ShowLabel" class="padding-left-5">Reject</ng-container>
  </a>
</div>
